"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
require("core-js/modules/es.array.concat");
require("core-js/modules/es.object.define-property");
require("core-js/modules/es.object.to-string");
require("core-js/modules/es.promise");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.check = check;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
function check(_x) {
  return _check.apply(this, arguments);
}
function _check() {
  _check = (0, _asyncToGenerator2["default"])(/*#__PURE__*/
  _regenerator["default"].mark(function _callee(withCredentials) {
    var headers, res, result;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            headers = new Headers();
            headers.append('Accept', 'application/json');
            headers.append('Content-Type', 'application/json');
            _context.next = 5;
            return fetch("".concat(this.url, "/check"), {
              method: 'POST',
              mode: 'cors',
              body: JSON.stringify({
                withCredentials: withCredentials
              }),
              headers: headers,
              credentials: 'include' // Don't forget to specify this if you need cookies
            });
          case 5:
            res = _context.sent;
            if (res.ok) {
              _context.next = 8;
              break;
            }
            throw Error("".concat(res.status, ": ").concat(res.statusText));
          case 8:
            _context.next = 10;
            return res.json();
          case 10:
            result = _context.sent;
            if (!(!result || !result.token)) {
              _context.next = 13;
              break;
            }
            throw Error('No token received, unauthorized');
          case 13:
            if (this.firebase) {
              this.signInWithCustomToken(result.token);
            }
            return _context.abrupt("return", result);
          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _check.apply(this, arguments);
}